module.exports = __webpack_public_path__ + "img/rewind.11ec24ea.svg";